<template>
  <div id="signIn" :class="{oauthError: error}">
    <div class="signInForm loading" v-if="loading"></div>
    <div class="signInForm" v-else-if="error">
      <div class="logo">
        <img src="../assets/logo.png">
        CMSRiver
      </div>
      <br/>
      <h4>Auth Error</h4>
      <p v-html="error"></p>
      <a class="btn btnPrimary" href="/signin">Try Again</a>
      <a class="btn btnSecondary" href="https://cmsriver.com">Back to Home</a>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      error: null,
      loading: true,
    };
  },
  methods: {},
  mounted() {
    /**
     * Check state
     *
     */
    const { state } = this.$route.query;
    if (!state) {
      this.error = 'State does not match';
      return;
    }

    /**
     * Check auth code
     *
     */
    const { code } = this.$route.query;
    if (!code) {
      this.error = this.$route.query.error || 'Internal server error, please try again later.';
      return;
    }

    /**
     * Exhcnage for token
     *
     */
    this.$http.post(this.$config.uri('user/auth/signin'), { code }).then((r) => {
      this.loading = false;
      if (r.data.status !== 200) {
        this.error = r.data.message || 'Internal server error, please try again later.';
        return;
      }
      if (r.data.user.mainOrganization) this.$session.set(`${this.$config.appId}_org`, r.data.user.mainOrganization.id);
      this.$session.set(`${this.$config.appId}_name`, r.data.user.name);
      this.$session.set(`${this.$config.appId}_email`, r.data.user.email);
      this.$session.set(`${this.$config.appId}_avatar`, r.data.user.avatar);
      this.$session.set(`${this.$config.appId}_jwt`, r.data.token);
      window.location.href = `${this.$config.appPath}`;
    }).catch((err) => {
      console.error(err); // eslint-disable-line
      this.loading = false;
      this.error = 'Internal server error, please try again later.';
    });
  },
};
</script>

<style scoped lang="scss">
#signIn{
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  z-index: 999;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  h4{
    font-size: 34px;
    margin: 14px 0 8px;
    color: #555;
    line-height: 1;
  }
  p{
    color: #767676;
    margin: 0;
    margin-bottom: 30px;
    line-height: 1.3;
  }
  .logo{
    font-size: 17px;
    color: #444;
    line-height: 1;
    font-weight: 600;
    display: flex;
    align-items: center;
    span{
      display: block;
    }
    img{
      margin-right: 10px;
      height: 34px;
    }
  }
  .btn{
    display: inline-block;
    margin-right: 10px;
    font-weight: 600;
  }
  .btn[disabled]{
    background-color: #eee !important;
    border-color: #eee !important;
    box-shadow: none !important;
    color: #ccc;
    cursor: default;
    &.btnLoading{
      background-color: #ccc !important;
      border-color: #ccc !important;
    }
  }
  .loading{
    margin-top: -20px;
    height: 100px; width: 100px;
    background-image: url(../assets/loading-3.svg);
    background-position: center;
    background-size: 50px auto;
    background-repeat: no-repeat;
    position: relative;
    z-index: 9;
    &:before{
      content: "";
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background-image: url(../assets/cmsriver-logo-loading.png);
      background-size: 28px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .signInForm{
    width: 320px;
    margin-top: -40px;
  }
  .copyright{
    position: fixed;
    bottom: 10px;
    left: 30px; right: 30px;
    font-size: 14px;
    color: #767676;
    @media (max-width: 767px) {
      left: 20px; right: 20px; bottom: 20px;
      // text-align: center;
    }
    .span2{
      margin-left: 20px;
      @media (max-width: 767px) {
        display: block;
        margin: 0;
        padding: 3px 0 0;
      }
      a{
        color: #444;
        margin-right: 30px;
        @media (max-width: 767px) {
          margin-right: 10px;
          display: inline-block;
        }
      }
      a:hover{
        color: #065feb;
      }
    }
    .poweredBy{
      position: absolute;
      top: 0px;
      right: 0px;
      @media (max-width: 767px) {
        top: auto;
        bottom: -1px;
        text-align: right;
      }
      a{
        color: #6f6f6f;
        @media (max-width: 767px) {
          display: block;
          margin-top: 5px;
        }
      }
      .logo{
        display: inline-block;
        width: 18px;
        height: 18px;
        background-image: url(../assets/cmsriver-logo.png);
        background-size: cover;
        border-radius: 50%;
        margin: 0 0 -4px 8px;
      }
      span{
        margin: 0;
        color: #2a3cb0;
        font-weight: 600;
      }
    }
  }
  &.oauthError{
    background-color: #ffebeb;
    color: red;
    h4, p{
      color: red;
    }
  }
}
</style>
